import { intl } from "LocaleWrapper";
import { PageHeader, Card } from "@cofano/cck";
import { Tabs, Tab, Box } from "@mui/material";
import { Language } from "imports/Utils";
import useTabs from "components/hooks/useTabs";
import Helmet from "components/helmet/Helmet";
import TemplateDefaultTable from "./components/tables/TemplateDefaultTable";
import TemplateCargoTable from "./components/tables/TemplateCargoTable";
import TemplateAgreementTable from "./components/tables/TemplateAgreementTable";
import { TemplateTabs } from "./utils/TemplateUtils";

const Templates = () => {

	const { selectedTab, selectTab } = useTabs<TemplateTabs>({
		defaultSelected: TemplateTabs.Default,
	});

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					{Language("TEMPLATES_TITLE")}
					<Helmet title={intl.formatMessage({ id: "TEMPLATES_TITLE" })} />
				</PageHeader.Title>
			</PageHeader>

			<Box mb={2}>
				<Card disablePadding>
					<Tabs value={selectedTab} onChange={(event, newValue) => selectTab(newValue)}>
						<Tab label={Language("DEFAULT")} value={TemplateTabs.Default} />
						<Tab label={Language("CARGOS")} value={TemplateTabs.Cargos} />
						<Tab label={Language("AGREEMENTS")} value={TemplateTabs.Agreements} />
					</Tabs>
				</Card>
			</Box>

			<Card disablePadding>
				{selectedTab === TemplateTabs.Default && (
					<TemplateDefaultTable />
				)}

				{selectedTab === TemplateTabs.Cargos && (
					<TemplateCargoTable />
				)}

				{selectedTab === TemplateTabs.Agreements && (
					<TemplateAgreementTable />
				)}
			</Card>
		</div>
	);
};

export default Templates;
